<color-sketch
  [color]="color"
  [disableAlpha]="true"
  [width]="100"
  (onChangeComplete)="changeColor($event)"
></color-sketch>
